import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import logger from "../helpers/logger";
import axiosIns from "../common/interceptor/axios-interceptor";

//Rack Pricing Group
//Fetch Rack Pricing Group data
export const fetchRackPGData = async (noCache = false) => {
  try {
    const res = await axiosIns.get(
      `rackstar/rackpricinggroup?noCache=${noCache}`
    );
    return getSuccessRes(
      res.data || [],
      "Rack Pricing Group data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Rack Pricing Group data.`);
  }
};

// Update an existing Rack Pricing Group entry
export const updateRackPGData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/rackpricinggroup/${id}`,
      data
    );
    return getSuccessRes(
      res.data,
      "Rack Pricing Group data updated successfully!"
    );
  } catch (error) {
    logger.error("update Rack Pricing Group Data", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Rack Pricing Group Data.");
  }
};

//Add a Rack Pricing Group data
export const addRackPGData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/rackpricinggroup`,
      data
    );
    return getSuccessRes(
      res.data,
      "Rack Pricing Group data added successfully!"
    );
  } catch (error) {
    logger.error("add Rack Pricing Group Data", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Rack Pricing Group data.");
  }
};

//Delete Rack Pricing Group
export const deleteRackPGData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/rackpricinggroup/${id}`
    );
    return getSuccessRes(
      res.data || [],
      "Rack Pricing Group data deleted successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Rack Pricing Group data.`);
  }
};
